import React from 'react'
import './styles'

import ExternalLink from '/components/external-link'
import Popover      from '/components/popover'

STRIPE_BASE_URL = "https://dashboard.stripe.com/"
urlFor = (host_account, client_account)->
  url = new URL STRIPE_BASE_URL
  url.pathname = "#{host_account}/connect/view-as/#{client_account}/payments/"
  url

export default StripeCharges = ({ ticket, hasPopover }) ->
  return null unless ticket

  { payment_references } = ticket
  return null unless num_charges = payment_references.length

  charge = (title) ->
    return null unless title

    { universe_stripe_connect_account_id, stripe_connect_account_id } = ticket
    return 'Stripe is not connected for this currency' unless stripe_connect_account_id

    url = urlFor universe_stripe_connect_account_id, stripe_connect_account_id

    if title?.match /^ch|^pi/i
      url.pathname += title

    <div key={title} className="charge">
      <span className="title" title={title}>{title}</span>
      <ExternalLink url={url.href} />
    </div>

  chargesGrid = ->
    for c in payment_references
      charge c

  <div className="StripeCharges">
    { if hasPopover and num_charges > 1
        <div className="chargesContainer">
          { charge "#{num_charges}x charges" }
          <Popover title="Charges">
            <div className="PopoverCharges">
              { chargesGrid() }
            </div>
          </Popover>
        </div>
      else
        chargesGrid()
    }
  </div>
